/* eslint-disable no-underscore-dangle */
import React from 'react';
import { AiOutlineArrowDown, AiOutlineArrowUp } from 'react-icons/ai';
import {
  calculateDifferenceTime,
  CreateSubscriptionNotification,
  ExpiredInvoicesNotification,
  FileNotification,
  NotificationsTypeNames,
  translatedNotificationsTypes,
  PlanApprovalRequestedNotification,
} from '..';
import { INotificationsProps } from '../../DropdownNotification';
import { IExpiredInvoiceNotificationProps } from '../components/ExpiredInvoiceNotification';
import { IFileNotificationProps } from '../components/FileNotification';
import { IPlanApprovalRequestedNotificationProps } from '../components/PlanApprovalRequestedNotification';
import UpdateSubscriptionNotification from '../components/UpdateSubscriptionNotification';
import {
  DefaultNotification,
  IDefaultNotificationProps,
} from '../DefaultNotification';
import { cn } from '../../../../lib/utils';

interface INotificationItem {
  notification: INotificationsProps;
  currentTime: Date;
  openAndCloseNotification: (id: string) => void;
}

type PropsNotifications = IDefaultNotificationProps;

interface INotificationTypes {
  [key: string]: (
    props: PropsNotifications,
    children?: React.ReactNode,
  ) => React.ReactNode;
}

export const NotificationsTypes: INotificationTypes = {
  'create-subscription': (props: PropsNotifications) => {
    return <CreateSubscriptionNotification {...props} />;
  },
  'update-subscription': (props: PropsNotifications) => {
    return <UpdateSubscriptionNotification {...props} />;
  },
  'expired-invoice': (props: PropsNotifications) => {
    return (
      <ExpiredInvoicesNotification
        {...(props as IExpiredInvoiceNotificationProps)}
      />
    );
  },
  file: (props: PropsNotifications) => {
    return <FileNotification {...(props as IFileNotificationProps)} />;
  },
  'plan-approval-requested': (props: PropsNotifications) => {
    return (
      <PlanApprovalRequestedNotification
        {...(props as IPlanApprovalRequestedNotificationProps)}
      />
    );
  },
  default: (props: PropsNotifications) => {
    return <DefaultNotification {...(props as IFileNotificationProps)} />;
  },
};

function NotificationItem({
  notification,
  currentTime,
  openAndCloseNotification,
}: INotificationItem) {
  const notificationParsed =
    typeof notification.content === 'object'
      ? notification.content
      : JSON.parse(notification.content);

  if (!(notificationParsed.type in NotificationsTypes)) {
    notificationParsed.type = 'default';
  }

  return (
    <li key={notification._id} className="list-none flex">
      {!notification.isRead && (
        <span className="flex w-[5px] h-[5px] rounded-full my-auto mr-[1px] bg-[var(--blue)]" />
      )}
      <div
        className={cn(
          'flex flex-col flex-1 mb-[2px] cursor-pointer rounded-lg px-[6px] transition-all duration-300 hover:bg-[rgba(0,113,188,0.1)]',
          !notification.isRead && 'bg-[rgba(0,113,188,0.1)]',
        )}
        onClick={() => openAndCloseNotification(notification._id)}
        onKeyDown={e => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            openAndCloseNotification(notification._id);
          }
        }}
        role="button"
        tabIndex={0}
      >
        <div className="flex items-center py-[5px] justify-between md:flex-row flex-col md:gap-0 gap-2">
          <span className="my-[0.3rem] text-base font-semibold">
            {
              translatedNotificationsTypes[
                notificationParsed.type as NotificationsTypeNames
              ]
            }
          </span>
          <small>
            {calculateDifferenceTime(notification.created_at, currentTime)}
          </small>
        </div>
        <div
          className={cn(
            notification.isOpen
              ? 'flex items-center max-h-[150px]'
              : 'flex flex-row justify-between py-[5px]',
          )}
        >
          {NotificationsTypes[
            notificationParsed.type as NotificationsTypeNames
          ]({
            created_at: notification.created_at,
            isOpen: notification.isOpen,
            ...notificationParsed,
          })}
          {notification.isOpen ? <AiOutlineArrowUp /> : <AiOutlineArrowDown />}
        </div>
      </div>
    </li>
  );
}

export { NotificationItem };
export default NotificationItem;
